import { RestClient } from '../lib/RestClient'

class AlunoServices extends RestClient {
  constructor() {
    super('aluno')
  }
}

export const Aluno = new AlunoServices()
